<template>
  <input-widget
     :model="model" :attribute="attribute" :rules="rules"
    type="select2"
    display-field="${item.key}" value-field="value" :items="states" @select2Select="onSelect"
    @select2Unselect="onUnselect">
  </input-widget>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import InputWidget from "../components/input-widget/InputWidget";

  const {mapGetters: globalMapGetters} = createNamespacedHelpers('global');

  export default {
    name: "StateInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      rules: {
        type: [String, Object],
        default: null
      },
    },
    data() {
      return {
        states: [
          {key: 'AL', value: 'AL'},
          {key: 'AK', value: 'AK'},
          {key: 'AZ', value: 'AZ'},
          {key: 'AR', value: 'AR'},
          {key: 'CA', value: 'CA'},
          {key: 'CO', value: 'CO'},
          {key: 'CT', value: 'CT'},
          {key: 'DE', value: 'DE'},
          {key: 'FL', value: 'FL'},
          {key: 'GA', value: 'GA'},
          {key: 'HI', value: 'HI'},
          {key: 'ID', value: 'ID'},
          {key: 'IL', value: 'IL'},
          {key: 'IN', value: 'IN'},
          {key: 'IA', value: 'IA'},
          {key: 'KS', value: 'KS'},
          {key: 'KY', value: 'KY'},
          {key: 'LA', value: 'LA'},
          {key: 'ME', value: 'ME'},
          {key: 'MD', value: 'MD'},
          {key: 'MA', value: 'MA'},
          {key: 'MI', value: 'MI'},
          {key: 'MN', value: 'MN'},
          {key: 'MS', value: 'MS'},
          {key: 'MO', value: 'MO'},
          {key: 'MT', value: 'MT'},
          {key: 'NE', value: 'NE'},
          {key: 'NV', value: 'NV'},
          {key: 'NH', value: 'NH'},
          {key: 'NJ', value: 'NJ'},
          {key: 'NM', value: 'NM'},
          {key: 'NY', value: 'NY'},
          {key: 'NC', value: 'NC'},
          {key: 'ND', value: 'ND'},
          {key: 'OH', value: 'OH'},
          {key: 'OK', value: 'OK'},
          {key: 'OR', value: 'OR'},
          {key: 'PA', value: 'PA'},
          {key: 'RI', value: 'RI'},
          {key: 'SC', value: 'SC'},
          {key: 'SD', value: 'SD'},
          {key: 'TN', value: 'TN'},
          {key: 'TX', value: 'TX'},
          {key: 'UT', value: 'UT'},
          {key: 'VT', value: 'VT'},
          {key: 'VA', value: 'VA'},
          {key: 'WA', value: 'WA'},
          {key: 'WV', value: 'WV'},
          {key: 'WI', value: 'WI'},
          {key: 'WY', value: 'WY'},
        ]
      }
    },
    computed: {
      ...globalMapGetters([
        'isAvalaraEnabled',
      ]),
    },
    methods: {
      onSelect(item) {
        this.$emit('select', item);
      },
      onUnselect(item) {
        this.$emit('unselect', item);
      },
    },
  }
</script>

<style scoped>

</style>
